import type { DeepRequired } from '../fixtures.types'

const mortgage: DeepRequired<Mortgage> = {
  __typename: 'Mortgage',
  id: 'TEST_ID',
  mortgage_id: 'TEST_ID',
  mortgage_product_id: 'TEST_ID',
  acre_dip_id: 'TEST_ID',
  additional_loan: null,
  application_date: null,
  arrears_summary: null,
  assumes_continuing: null,
  calculated_values: null,
  case_id: 'TEST_ID',
  case_ids: ['TEST_ID'],
  client_ids: ['TEST_ID'],
  clients: [],
  current_monthly_payment: null,
  dip_amount: null,
  dip_status: null,
  early_repayment_charge_amount: null,
  eor_document_ids: [],
  esis_document_id: null,
  external: null,
  fees_to_be_added: [],
  first_or_second_charge: null,
  has_arrears: null,
  initial_rate_end_date: null,
  interest_only_amount: null,
  lender_proposed: null,
  loan_benefits_all_applicants: null,
  loan_completion_date: null,
  loan_contract_exchange_date: null,
  monthly_payment: null,
  mortgage_account_number: null,
  mortgage_amount: null,
  mortgage_end_date: null,
  mortgage_product: null,
  mortgage_product_select_reason: null,
  mortgage_product_source_rank: null,
  mortgage_productCp: null,
  mortgage_redemption_date: null,
  mortgage_repaid_date: null,
  mortgage_start_date: null,
  offer_expiry_date: null,
  outstanding_balance: null,
  outstanding_balance_date: null,
  payment_history: null,
  payment_status_summary: null,
  property: null,
  property_purchase_date: null,
  property_secured_ids: [],
  property_value: null,
  provider_application_reference: null,
  provider_dip_reference: null,
  raw_results_reference: null,
  repayment_amount: null,
  repayment_vehicle_current_value_of_vehicle: null,
  repayment_vehicle_declared_maturity_amount: null,
  repayment_vehicle_monthly_contribution: null,
  requires_offset_facility: null,
  revert_monthly_payment: null,
  selected_mortgage_club_code: null,
  source_response: null,
  status: null,
  term: null,
  term_unit: null,
  valuation_type: null,
  version: null,
  will_be_repaid_by_mortgage_id: null,
  versions: [],
  dip_details: null,
  reason_for_true_cost_calculation_change: null,
  document_requirements: [],
}

export default mortgage
